document.addEventListener("DOMContentLoaded", function() {
  // Selecciona todos los h3 que contengan el texto "Mercado Pago"
  const paymentHeaders = document.querySelectorAll("h3");

  paymentHeaders.forEach(header => {
    if (header.textContent.trim() === "Mercado Pago") {
      header.textContent = "Tarjeta de Débito o Crédito (Mercado Pago)";
    }
  });
});
